/**
 *
 * Section Step4 - Your opt out | PDF, OK & payment
 *
 */
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import BackSvg from "../partials/BackSvg.jsx";
import ButtonMore from "../partials/ButtonMore.jsx";
import LocalDate from "../partials/LocalDate.jsx";
import Invoice from "../components/Invoice.jsx";
import Pingen from "../components/Pingen.jsx";
import Order from "../lib/Order.jsx";

/* Forms */
import { Input } from "../components/Input.jsx";
import { FormProvider, useForm } from "react-hook-form";
import { email_validation } from "../utils/inputValidations";

function Step4(props) {
  useEffect(() => {
    if (props.formData.senderReverseEmail == "") {
      props.formData.senderReverseEmail = props.formData.senderEmail;
    }
    readPaymentTokenFromUrl();
  });

  // Flag to indicate the the letter is posted to Pingen
  const [canPingen, setCanPingen] = useState(false);

  /* Payment option */
  const [paymentOption, setPaymentOption] = useState(0);

  // ReadMore button(s)
  const [readMore1, setReadMore1] = useState(false);
  const toggleReadMore1 = () => setReadMore1((prev) => !prev);

  // next is enabled when payment option selection is done
  const [disableNextStep, setDisableNextStep] = useState(true);

  /**
   * read Payment Token From Url
   *
   * After a payment is done Mollie redirects back to our site with a query string:
   *
   *     ?section=step4&paymenttoken=xxxxxxx
   *
   * This unique `paymenttoken` is used in the backend API that the payment is done
   * and we can post the letter to Pingen
   *
   */
  const readPaymentTokenFromUrl = (e) => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("paymenttoken") && props.formData.paymentToken == "") {
      props.emitUpdateFormdata("paymentToken", queryParams.get("paymenttoken"));
      // trigger posting by Pingen
      setCanPingen(true);
    }
  };

  /**
   * Select donation amount after clicking a donation button
   *
   */
  const selectDonation = (option, e) => {
    props.emitUpdateFormdata("paymentChoice", option);
    setPaymentOption(option);
    setDisableNextStep(parseInt(option) == 0);
  };

  /**
   * Forms
   *
   */

  /**
   * Update a form change formData
   * @param {*} e
   */
  const handleChange = (e) => {
    props.emitUpdateFormdata(e.target.name, e.target.value);
  };

  const methods = useForm();
  const onSubmit = methods.handleSubmit((data) => {
    // create invoice number, which indicates that we can pay
    let orderNumber = Order.createNumber();
    props.emitUpdateFormdata("orderNumber", orderNumber);
  });

  return (
    <div className="step" id="step4">
      <Invoice
        formData={props.formData}
        emitChangeSection={props.emitChangeSection}
      />
      <Pingen
        formData={props.formData}
        canPingen={canPingen}
        emitChangeSection={props.emitChangeSection}
      />
      {/* Headline & Intro */}
      <div className="row">
        <div className="col col-10">
          <h1 className="headline">Your OptOut</h1>
          <div className="progress bar3">&nbsp;</div>
        </div>
      </div>
      <div className="row">
        <div className="col col-8">
          <p className="intro">Since there is no way to deliver this digitally (yet), we deliver by post. Proven technology.</p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="letter">
            <div className="letterAddress">
              <div className="recipient">
                <p>
                  {props.formData.recipientOrganization}
                  <br />
                  {props.formData.recipientTitle != "" && (
                    <>
                      {props.formData.recipientTitle} <br />
                    </>
                  )}
                  {props.formData.recipientFirstName != "" && (
                    <>
                      {props.formData.recipientFirstName} <br />
                    </>
                  )}
                  {props.formData.recipientLastName != "" && (
                    <>
                      {props.formData.recipientLastName} <br />
                    </>
                  )}
                  {props.formData.recipientAddress1}
                  <br />
                  {props.formData.recipientAddress2}
                  <br />
                  {props.formData.recipientCity}
                  <br />
                  {props.formData.recipientCountry}
                  <br />
                </p>
              </div>
              <div className="sender">
                <p>
                  <strong>From</strong>
                  <br />
                  {props.formData.senderFirstName}{" "}
                  {props.formData.senderLastName}
                  <br />
                  {props.formData.senderAddress1}
                  <br />
                  {props.formData.senderAddress2}
                  <br />
                  {props.formData.senderCity}
                  <br />
                  {props.formData.senderCountry}
                  <br />
                </p>
                <p>
                  Date of Birth{" "}
                  {props.formData.senderBirthDate}
                  <br />
                  ID: {props.formData.senderId}
                  <br />
                  Phone:{" "}
                  {props.formData.senderPhone}
                  <br />
                  Email:{" "}
                  {props.formData.senderEmail}
                  <br />
                </p>
              </div>
            </div>
            <div className="letterMeta">
              <p>
                <strong>Date: </strong>
                <LocalDate localeCode={props.formData.locale} />
                <br />
                <strong>Subject: </strong>
                OptOut for the European Health DataSpace (EHDS)
              </p>
            </div>
            <div
              className={
                readMore1 ? "letterBody fadeIn" : "letterBody readLess"
              }
            >
              {props.formData.recipientLastName != "" && (
                <p>
                  Dear&nbsp;
                  {props.formData.recipientTitle != "" && (
                    <>{props.formData.recipientTitle}&nbsp;</>
                  )}
                  {props.formData.recipientFirstName != "" && (
                    <>{props.formData.recipientFirstName}&nbsp;</>
                  )}
                  {props.formData.recipientLastName}
                </p>
              )}
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel sem ex. Curabitur finibus augue purus, eget pharetra turpis convallis ac. Pellentesque efficitur elementum bibendum. Cras pretium risus eu rutrum dictum. Nam tristique sapien nulla, eu euismod enim vehicula in. Sed tempus dui finibus urna porttitor tempor. Proin nunc risus, aliquam in libero quis, accumsan feugiat arcu. Nam ut semper leo. Nulla facilisi. Maecenas commodo varius mauris, dignissim ullamcorper purus pellentesque quis. Etiam sit amet mi sit amet purus feugiat pretium.
              <br /> <br />
              {props.formData.senderFirstName} {props.formData.senderLastName}
            </div>
            {/*letterbo*/}

            <ButtonMore readMore={readMore1} toggleReadMore={toggleReadMore1} />
          </div>
          {/*letter*/}
        </div>
        {/*col*/}
      </div>
      {/*row*/}

      <div className="row">
        <div className="col-8">
          <h3>Receive a copy</h3>
          <p className="mb-10">You will receive instructions on how to reverse your opt-out.</p>
          <FormProvider {...methods}>
            <form
              onSubmit={(e) => e.preventDefault()}
              noValidate
              className="container"
            >
              <Input
                label=" "
                placeholder="e-mail@address.com"
                value={props.formData.senderReverseEmail}
                type="text"
                name="senderReverseEmail"
                handleChange={(e) => handleChange(e)}
                validation={{ ...email_validation }}
              />
            </form>
          </FormProvider>
        </div>
        {/*col*/}
      </div>
      {/*row*/}

      <div className="row">
        <div className="col col-8">
          <h3>Donate</h3>
          <p className="mb-30">We are an NGO and run non-profit. Please pay from an account that is in your name, since this is also used for identification. You can only OptYourselfOut.</p>

          <div className="donate flex-center">
            <div
              className="donateOption"
              data-selected={paymentOption === 1 ? "true" : "false"}
            >
              <div
                className="button buttonDonate"
                onClick={(e) => selectDonation(1, e)}
              >
                &euro;0.01
              </div>
              <div className="donateLabel">
                Feel free, if you can't afford more.
              </div>
            </div>

            <div
              className="donateOption"
              data-selected={paymentOption === 2 ? "true" : "false"}
            >
              <div
                className="button buttonDonate"
                onClick={(e) => selectDonation(2, e)}
              >
                &euro;2
              </div>
              <div className="donateLabel">
                Pay for your own.
              </div>
            </div>

            <div
              className="donateOption"
              data-selected={paymentOption === 3 ? "true" : "false"}
            >
              <div
                className="button buttonDonate"
                onClick={(e) => selectDonation(3, e)}
              >
                &euro;4
              </div>
              <div className="donateLabel">
                Pay it forward, donate a letter.
              </div>
            </div>

            <div
              className="donateOption"
              data-selected={paymentOption === 4 ? "true" : "false"}
            >
              <div
                className="button buttonDonate"
                onClick={(e) => selectDonation(4, e)}
              >
                &euro;10
              </div>
              <div className="donateLabel">
                Support this app. We work non-profit!
              </div>
            </div>
          </div>
        </div>
        {/*col*/}
      </div>

      <div className="row">
        <div className="col flex-center">
          <div
            className="button buttonBack"
            onClick={(e) => props.emitChangeSection("step3", e)}
          >
            <BackSvg />
            back
          </div>

          <div
            className="button buttonOptMeOut"
            disabled={disableNextStep}
            onClick={!disableNextStep ? (e) => onSubmit() : void 0}
          >
            Send it
          </div>
        </div>
        {/*col*/}
      </div>
      {/*row*/}
    </div>
  );
}

Step4.propTypes = {
  emitUpdateFormdata: PropTypes.func,
  emitChangeSection: PropTypes.func,
  formData: PropTypes.object,
};

export default Step4;
